import React from "react";

import { TextContainer } from "./styles";

const Text = ({ onChange = () => {}, value, placeholder }) => {
  return (
    <TextContainer
      type="text"
      placeholder={placeholder}
      value={value}
      onChange={({ target: { value } }) => onChange(value)}
    />
  );
};

export default Text;
